import {
  Box,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Spinner,
  Text,
  useStyleConfig,
  VStack,
} from "@chakra-ui/react";
import Image from "./_image";
import "./index.css";
import { useFirebase } from "../../wrappers/firebase";
import useUserStore from "../../store/userStore";
import { signOut } from "firebase/auth";
import { forwardRef } from "react";
import { shallow } from "zustand/shallow";
import { FiLogOut, FiSettings, FiUser } from "react-icons/fi";
import { TiFlash } from "react-icons/ti";
import { useNavigate } from "react-router";
import { TbHelp } from "react-icons/tb";
import { FaBucket, FaFaceGrinWide } from "react-icons/fa6";
import formatNumberKMBT from "../../helpers/formatNumberKMBT";
import { useReportManager } from "../../wrappers/report";
import { useStripe } from "../../wrappers/stripe";
import { MdOutlineAttachMoney } from "react-icons/md";
import useReactiveQuery from "../../hooks/data/useReactiveQuery";
import { UserProvider } from "./provider";

/**
 * User menu (subscription, profile, logout)
 */
export default function ButtonViewUser(props) {
  const { auth } = useFirebase();
  const { subscription_migration_status } = useUserStore(
    (state) => state.user,
    shallow
  );
  const { username } = useUserStore((state) => state.user, shallow);
  const { togglePriceModal, customerIsPRO, toggleAccountMgmtModal } =
    useStripe();
  const navigate = useNavigate();

  const { triggerReportProblem } = useReportManager();

  const isMigrating = subscription_migration_status === "pending";

  async function performLogout() {
    await signOut(auth);
  }

  function goToProfile() {
    navigate(`/user/${username}`);
  }

  function goToPurchases() {
    navigate("/my-purchases");
  }

  return (
    <UserProvider user={props}>
      <Box>
        <Menu placement="bottom" w="150px">
          <MenuButton
            as={IconButton}
            icon={<Image h="full" w="full" />}
            color="gray.400"
            h="40px"
            w="40px"
            variant={"nav"}
            bg="none"
            minH={"0"}
            minW="0"
            borderRadius={"full"}
            cursor={"pointer"}
            border="1px solid"
            borderColor={"gray.600"}
            _hover={{
              color: "white",
              bg: "#313134",
              borderColor: 'gray.400'
            }}
            p="0.5"
          />
          <MenuList color="white" p="1">
            <MenuGroup>
              <MenuItem onClick={togglePriceModal} isDisabled={isMigrating}>
                {isMigrating ? (
                  <Spinner size="xs" color="white" />
                ) : (
                  <FiSettings />
                )}
                <Text>
                  {isMigrating
                    ? "Updating Subscription"
                    : "Manage Subscription"}
                </Text>
              </MenuItem>
              <MenuItem onClick={goToProfile}>
                <FiUser />
                <Text>My Profile</Text>
              </MenuItem>
            </MenuGroup>
            <MenuDivider />
            <MenuGroup>
              <MenuItem onClick={triggerReportProblem}>
                <TbHelp />
                <Text>Get help</Text>
              </MenuItem>
              <MenuItem onClick={performLogout}>
                <FiLogOut />
                <Text>Log out</Text>
              </MenuItem>
              {/* <MenuItem onClick={() => navigate("/test")}>
                <FiLogOut />
                <Text>Go to test page</Text>
              </MenuItem> */}
            </MenuGroup>
          </MenuList>
        </Menu>
      </Box>
    </UserProvider>
  );
}
